// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import {format, addDays} from "date-fns"
import Flatpickr from "react-flatpickr"
import Select from "react-select"

import {addPlanningItem} from "../../actions/planning"
import {fetchBabies} from "../../actions/babies"
import type {
  State as ReduxState,
  Baby,
  PlanningItem,
  Dispatch,
} from "../../types"

type Props = {
  +t: any,
  +babyId: ?number,
  +babies: $ReadOnlyArray<Baby>,
  +dispatch: Dispatch,
  +handleCloseModal: () => void,
  +handleAfterOpen: () => void,
}

type State = {
  +babyId: ?number,
  +planningItem: PlanningItem,
}

type FlatpickrInstance = any

const initialPlanningItem = (babyId: ?number) => ({
  description: "",
  key: null,
  id: null,
  babyId,
  type: "madam",
  date: format(new Date(), "YYYY-MM-DD"),
  dueDate: format(addDays(new Date(), 1), "YYYY-MM-DD"),
  isActionable: true,
  baby: null,
})

class PlanningItemAddModal extends React.Component<Props, State> {
  handleSave: () => void
  handleBabyChange: (Object, Object) => void
  handleInputChange: (SyntheticInputEvent<HTMLTextAreaElement>) => void
  handleDateChange: ($ReadOnlyArray<Date>, string, FlatpickrInstance) => void

  constructor(props: Props) {
    super(props)

    this.state = {
      babyId: this.props.babyId,
      planningItem: initialPlanningItem(this.props.babyId),
    }

    this.handleSave = this.handleSave.bind(this)
    this.handleBabyChange = this.handleBabyChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(fetchBabies())
  }

  handleInputChange(e: SyntheticInputEvent<HTMLTextAreaElement>) {
    this.setState({
      planningItem: {
        ...this.state.planningItem,
        description: e.currentTarget.value,
      },
    })
  }

  handleBabyChange(value: Object, action: Object) {
    if (action.action == "select-option") {
      this.setState({
        planningItem: {
          ...this.state.planningItem,
          babyId: value.value,
        },
      })
    }
  }

  handleDateChange(dates: $ReadOnlyArray<Date>, dateStr: string) {
    dates.forEach((d) => d)
    this.setState({
      planningItem: {
        ...this.state.planningItem,
        date: dateStr,
        dueDate: dateStr,
      },
    })
  }

  handleSave() {
    const {planningItem} = this.state
    const {dispatch, handleCloseModal} = this.props
    const {babyId, description} = planningItem
    if (babyId && description.length) {
      dispatch(addPlanningItem(planningItem))
      handleCloseModal()
    }
  }

  renderBody() {
    const {t, babies} = this.props
    const {planningItem} = this.state
    const options = babies.map((baby) => {
      return {
        value: baby.id,
        label: baby.family.users.map((u) => u.firstname).join(" & "),
      }
    })
    const currentValue = options.find(
      (option) => String(option.value) == String(planningItem.babyId)
    )

    return (
      <>
        <div className="form-group">
          <label htmlFor="baby">{t("dashboard.planning.create.baby")}</label>
          <Select
            id="baby"
            className="basic-single"
            classNamePrefix="select"
            value={currentValue}
            onChange={this.handleBabyChange}
            isSearchable={true}
            name="baby"
            options={options}
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">
            {t("dashboard.planning.create.description")}
          </label>
          <textarea
            className="form-control"
            id="description"
            autoFocus={true}
            maxLength={5000}
            onChange={this.handleInputChange}
            value={planningItem.description}
          />
        </div>
        <div className="form-group">
          <label htmlFor="date">{t("dashboard.planning.create.date")}</label>
          <Flatpickr
            options={{
              altFormat: "d/m/Y",
              dateFormat: "Y-m-d",
              altInput: true,
            }}
            value={planningItem.date}
            onChange={this.handleDateChange}
            id="date"
          />
        </div>
        <button className="btn btn-primary" onClick={this.handleSave}>
          {t(`dashboard.planning.create.save`)}
        </button>
      </>
    )
  }

  render() {
    const {t} = this.props
    return (
      <Modal
        className="modal-dialog modal-sm"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.handleCloseModal}
        onAfterOpen={this.props.handleAfterOpen}
        contentLabel={t("dashboard.planning.create.title")}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {t("dashboard.planning.create.title")}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("dashboard.planning.create.close")}
              onClick={this.props.handleCloseModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body pt-0">{this.renderBody()}</div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  babies: state.babies.entities,
})

export default withTranslation()(connect(mapStateToProps)(PlanningItemAddModal))
